import { z } from "zod";

import { type JoinSpec, type join, joinSpecSchema } from "./join";
import {
	type LeftOuterJoinSpec,
	type leftOuterJoin,
	leftOuterJoinSpecSchema,
} from "./leftOuterJoin";
import { type OrderedTopKSpec, type orderedTopK, orderedTopKSpecSchema } from "./orderedTopK";
import { type SemijoinSpec, type semijoin, semijoinSpecSchema } from "./semijoin";
import { type WhereSpec, type where, whereSpecSchema } from "./where";

export const operatorSpecSchema = z.discriminatedUnion("type", [
	whereSpecSchema,
	semijoinSpecSchema,
	joinSpecSchema,
	orderedTopKSpecSchema,
	leftOuterJoinSpecSchema,
]);
export type OperatorSpec = z.infer<typeof operatorSpecSchema>;

export type Operator =
	| (WhereSpec & { logic: ReturnType<typeof where> })
	| (SemijoinSpec & { logic: ReturnType<typeof semijoin> })
	| (JoinSpec & { logic: ReturnType<typeof join> })
	| (OrderedTopKSpec & { logic: ReturnType<typeof orderedTopK> })
	| (LeftOuterJoinSpec & { logic: ReturnType<typeof leftOuterJoin> });
